
import Datetime from 'vux/src/components/datetime/index.vue'


export default {
name: 'workOrderSolution',
components: {
Datetime
},
data () {
return {
formData:{
id:0,
labels:'',
content:'',
deadline:'',
},
labels:[],
datetimeStatus:false,
startDate:'',
endDate:'',
minHour:6,
maxHour:24,
days:30,
}
},
created(){
this.formData.id = Number(this.$route.params.id);
this.setDate();
this.visitLabels();
},
mounted(){

},
activated(){

},
methods:{
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
hour: nowDate.getHours(),
}
this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
var date = new Date(this.startDate);
date.setDate(date.getDate() + this.days);
var date1 = {
year: date.getFullYear(),
month: date.getMonth() + 1,
day: date.getDate(),
}
this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
this.formData.deadline = this.startDate;
},
datetimeChange(val){
this.formData.deadline = val;
this.datetimeStatus = false;
},
addLabel(title){
if(title){
this.formData.labels += '#'+title;
}else{
this.formData.labels += '#';
}
this.$refs.textarea.focus();
},
visitLabels(){
this.$api.visitLabels({type:1}).then((res)=>{
if(res){
this.labels = res.data;
}
})
},
submit(){
if(!this.formData.id){
this.$func.showToast('系统错误，请稍后再试');
return false;
}
if(!this.formData.labels){
this.$func.showToast('请输入处理办法');
return false;
}
if(!this.formData.deadline){
this.$func.showToast('请选择截止时间');
return false;
}
this.$api.submitSolution(this.formData).then((res)=>{
if(res){
this.$func.showToast('提交成功');
setTimeout(()=>{
this.$router.go(-1);

},1000)
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/workOrderSolution.vue